import { useState } from 'react';
import { Icon } from '../editor/chrome/icons';
import { tip } from '../ui/tooltip';

/** Search as a round button that opens into a field, and closes again when left empty. */
export function Search({ value, onChange }: { value: string; onChange: (value: string) => void }) {
  const [open, setOpen] = useState(value !== '');
  if (!open && value === '')
    return (
      <button type="button" aria-label="Search" {...tip('Search')} onClick={() => setOpen(true)} className="glass grid size-[34px] place-items-center rounded-full text-label-2 hover:text-label">
        <Icon name="search" size={16} />
      </button>
    );
  return (
    <label className="flex h-[32px] w-[150px] items-center sm:w-[220px] gap-[7px] rounded-full bg-fill-1 px-[11px] field-focus">
      <span className="text-label-3">
        <Icon name="search" size={14} />
      </span>
      <input
        autoFocus={value === ''}
        type="search"
        aria-label="Search"
        placeholder="Search"
        value={value}
        onChange={(event) => onChange(event.target.value)}
        onKeyDown={(event) => {
          if (event.key !== 'Escape') return;
          onChange('');
          setOpen(false);
        }}
        onBlur={() => value === '' && setOpen(false)}
        className="w-0 min-w-0 flex-1 bg-transparent text-[13px] text-label outline-none placeholder:text-label-3"
      />
    </label>
  );
}
